import { render, staticRenderFns } from "./KgResourceListBar.vue?vue&type=template&id=28382e0b&scoped=true"
import script from "./KgResourceListBar.vue?vue&type=script&lang=js"
export * from "./KgResourceListBar.vue?vue&type=script&lang=js"
import style0 from "./KgResourceListBar.vue?vue&type=style&index=0&id=28382e0b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28382e0b",
  null
  
)

export default component.exports